import Dexie, { type Table } from 'dexie';
import type { SessionResult } from '../types';

export interface UploadRecord {
  id: string;
  sessionId: string;
  status: 'pending' | 'uploaded' | 'failed';
  error?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SettingRecord {
  key: string;
  value: unknown;
  updatedAt: string;
}

class LimenDexie extends Dexie {
  sessions!: Table<SessionResult, string>;
  uploads!: Table<UploadRecord, string>;
  settings!: Table<SettingRecord, string>;

  constructor() {
    super('limen-lab.v1');
    this.version(1).stores({
      sessions: 'id, modality, createdAt',
      uploads: 'id, sessionId, status, updatedAt',
      settings: 'key'
    });
  }
}

export const db = new LimenDexie();

export async function saveSession(result: SessionResult): Promise<void> {
  await db.sessions.put(result);
  await db.uploads.put({
    id: crypto.randomUUID(),
    sessionId: result.id,
    status: 'pending',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
}

export async function listRecentSessions(limit = 12): Promise<SessionResult[]> {
  return db.sessions.orderBy('createdAt').reverse().limit(limit).toArray();
}
